import { useEffect } from "react";
import { useAppNotifications } from "@/hooks/useAppNotifications";
import {
  registerForbiddenApiToastNotifier,
  unregisterForbiddenApiToastNotifier,
} from "@/utils/forbiddenApiError";

export function ForbiddenApiToastRegistry() {
  const notifications = useAppNotifications();

  useEffect(() => {
    registerForbiddenApiToastNotifier(notifications);
    return () => {
      unregisterForbiddenApiToastNotifier();
    };
  }, [notifications]);

  return null;
}
